module.exports = __webpack_public_path__ + "static/img/emoji_3.33c71140.png";